import React from 'react';

/**
 * MaterialIcon - Komponenta pre Material Symbols ikony
 * @param {string} icon - Názov ikony z Material Symbols
 * @param {number} size - Veľkosť ikony v px (default: 24)
 * @param {string} variant - Variant: 'outlined' | 'rounded' | 'sharp' (default: 'outlined')
 * @param {object} style - Dodatočné CSS štýly
 * @param {string} className - Dodatočné CSS triedy
 */
const MaterialIcon = ({ 
  icon, 
  size = 24, 
  variant = 'outlined', 
  style = {}, 
  className = '',
  ...props 
}) => {
  const variantClass = {
    'outlined': 'material-symbols-outlined',
    'rounded': 'material-symbols-rounded',
    'sharp': 'material-symbols-sharp'
  }[variant] || 'material-symbols-outlined';

  return (
    <span
      className={`${variantClass} ${className}`}
      style={{
        fontSize: `${size}px`,
        width: `${size}px`,
        height: `${size}px`,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        userSelect: 'none',
        ...style
      }}
      {...props}
    >
      {icon}
    </span>
  );
};

export default MaterialIcon;
